import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-login-overlay-section',
  templateUrl: './login-overlay-section.component.html',
  styleUrls: ['./login-overlay-section.component.scss']
})
export class LoginOverlaySectionComponent implements OnInit {

  @Input()
  sessionID: string;

  @Input()
  userEmail: string;

  @Input()
  userName: string;

  @Input()
  userHasPassword: boolean;

  @Input()
  userHasPhoneNumber: boolean;

  @Output()
  closeOverlay: EventEmitter<any> = new EventEmitter();

  public loginType = null;
  public activeAltOption = null;

  constructor() { }

  ngOnInit() {
    this.loginType = this.userHasPassword ? 1 : 2;
  }

  toggleLoginType(type) {
    this.loginType = type;
  }

  handleCloseOverlay() {
    this.closeOverlay.emit();
  }

}
